import { GET_RESOURCE_FILE_API } from '../constants/AppConstants';

export default async (fileId) => {
  const URL = GET_RESOURCE_FILE_API.replace(':fileId', fileId);
  try {
    const response = await fetch(URL, { skipAuthHeader: true });
    const json = await response.json();
    if (response.status !== 200) return { ok: false, status: response.status, json };
    return { ok: true, status: response.status, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
